import vsComponent from './vsUpload';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
